import { MetycleLogo } from '@/components/metycle-logo';
import { SidebarHeader } from '@/components/ui/sidebar-sections';
import { cn } from '@/lib/utils';

export function SidebarBrand({ className }: Readonly<{ className?: string }>) {
  return (
    <SidebarHeader className={cn('items-center', className)}>
      <MetycleLogo />
    </SidebarHeader>
  );
}
